import type { FeedbackFormProps as StormFeedbackFormProps } from '@amzn/storm-ui-feedback-form-kit'

// en_AE locale is unavailable as there is no linguistic difference between en-US and en-AE
// https://code.amazon.com/packages/AACChromeCommon/blobs/mainline/--/configuration/brazil-config/global/AACChromeCommon.cfg#L160
const getStormLocale = (originlocale: string): StormFeedbackFormProps['locale'] => {
  const locale = originlocale.replace('_', '-') as StormFeedbackFormProps['locale'] | 'en-AE'
  switch (locale) {
    case 'en-AE': {
      return 'en-US'
    }
    default: {
      return locale
    }
  }
}

export default getStormLocale
